import axios from 'axios';
import { createCustomerRegisterUrl } from '../api-urls';
import translateErrors from './translate-errors';
import { pathOr } from 'ramda';
import { translateToCustomerPj } from './translate-to-customer';

function CustomerError(message, statusCode) {
  this.message = message;
  this.statusCode = statusCode;
}

const requestValidateCustomer = (customer, captchaResponse) => ({
  url: `${createCustomerRegisterUrl(captchaResponse)}&persist=false`,
  method: 'post',
  data: customer
});

const handleCreateCustomerPjError = error => {
  const { httpStatusCode, validationErrors, errorCode } = pathOr({}, ['response', 'data'], error);
  const translatedErrors = translateErrors(validationErrors);

  switch (httpStatusCode) {
    case 409:
      if (errorCode === "LOGIN_CONFLICT") {
        throw new CustomerError({ buyerAlreadyRegistered: 'revise seu e-mail e senha' }, httpStatusCode);
      }
      throw new CustomerError({ cnpj: 'CNPJ já está cadastrado, solicite acesso em sua empresa ou acesse nosso FAQ' }, httpStatusCode);

    case 422:
      throw new CustomerError(translatedErrors, httpStatusCode);

    default:
      throw new CustomerError({ default: '' }, httpStatusCode);
  }
};

export const validateCustomerPj = async (customer, captcha) => {
  try {
    const translatedCustomer = translateToCustomerPj(customer);
    const { data } = await axios(requestValidateCustomer(translatedCustomer, captcha));
    return data;
  } catch (error) {
    handleCreateCustomerPjError(error);
  }
};
